module.exports = __webpack_public_path__ + "img/msc.e3f8beb6.svg";